import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MarketplaceConfigState {
  supportedLanguages: string[];
  hasAffiliateSystem?: boolean;
}

const initialState: MarketplaceConfigState = {
  supportedLanguages: [],
  hasAffiliateSystem: false,
};

const marketplaceConfigSlice = createSlice({
  name: 'marketplaceConfig',
  initialState,
  reducers: {
    setSupportedLanguages(state, action: PayloadAction<string[]>) {
      state.supportedLanguages = action.payload;
    },
    setHasAffiliateSystem(state, action: PayloadAction<boolean>) {
      state.hasAffiliateSystem = action.payload;
    },
  },
});

export const { setSupportedLanguages, setHasAffiliateSystem } = marketplaceConfigSlice.actions;
export default marketplaceConfigSlice.reducer;
